import { Route } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";

import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";

const ProtectedRoute = ({ component, ...args }) => (
  <Route
    component={withAuthenticationRequired(component, {
      onRedirecting: () => <SpinnerIcon />,
    })}
    {...args}
  />
);

export default ProtectedRoute;
